import { render, staticRenderFns } from "./kaseya-send-company-widget.vue?vue&type=template&id=62c4e2a4&scoped=true&"
import script from "./kaseya-send-company-widget.vue?vue&type=script&lang=js&"
export * from "./kaseya-send-company-widget.vue?vue&type=script&lang=js&"
import style0 from "./kaseya-send-company-widget.vue?vue&type=style&index=0&lang=css&"
import style1 from "./kaseya-send-company-widget.vue?vue&type=style&index=1&id=62c4e2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c4e2a4",
  null
  
)

export default component.exports